<template>
		<div class="kids-linkage" ref="kidsLinkage">
			<transition name="kids-linkage-mask">
				<i v-if="visible" @click.self.stop="closeSelector" class="kids-linkage__mask"></i>
			</transition>
			<transition name="kids-linkage">
				<div class="kids-linkage--content"  :class="direction"  v-if="visible" >
					<div class="kids-linkage--main">

						<div class="kids-linkage--header">
							<span class="kids-linkage--header__title">所在地区</span>
							<i class="kids-linkage--header__icon_close" @click.self.stop="closeSelector"></i>
						</div>
						<div class="kids-linkage--label">
							<input hidden type="checkbox" id="province_empty" :checked="true" v-model="provinceSelecting_empty" >
							<label for="province_empty"  v-if="!province" @click.prevent="stopChangeState('provinceSelecting_empty')">请选择</label>
							<input hidden type="checkbox" id="province" v-model="provinceSelecting" >
							<label for="province"  v-if="province" @click.prevent="stopChangeState('provinceSelecting')">{{province}}</label>
							<input hidden type="checkbox" id="city_empty" v-model="citySelecting_empty" >
							<label for="city_empty" v-if="province && !provinceSelecting && !isMunicipality && !city"  @click.prevent="stopChangeState('citySelecting_empty')">城市</label>
							<input hidden type="checkbox" id="city"  v-model="citySelecting">
							<label for="city" v-if="city" @click.prevent="stopChangeState('citySelecting')">{{city}}</label>
							<input hidden type="checkbox" id="districtAndCounty_empty" v-model="districtAndCountySelecting_empty">
							<label for="districtAndCounty_empty" v-if="(city && !citySelecting  || isMunicipality) && !provinceSelecting && !districtAndCounty" @click.prevent="stopChangeState('districtAndCountySelecting_empty')">区县</label>
							<input hidden type="checkbox" id="districtAndCounty" v-model="districtAndCountySelecting">
							<label for="districtAndCounty"  v-if="districtAndCounty"  @click.prevent="stopChangeState($event, 'districtAndCountySelecting')">{{districtAndCounty}}</label>
						</div>
						<area-list :data="areaData" :default-val="defaultVal" :is-selecting-district="isSelectingDistrict" @selected="selectedNewVal"></area-list>
					</div>
				</div>
			</transition>
		</div>
</template>

<script>
		import areaList from './area_list'
		import {isMunicipality} from "./utils";

		export default {
			name: "linkage",
			components: {
				areaList
			},
			data () {
				return {
					visible: false,
					data: [],// 传入 areaList 组件 的数据
					direction: null,
					exportData: null,

					areaData: [],
					cityData: [],
					districtAndCountyData: [],
					defaultVal: '',
					isSelectingDistrict: false,

					province: null,
					city: null,
					districtAndCounty: null,

					provinceSelecting: false, // 正在选择省份， 已选中
					citySelecting: false,
					districtAndCountySelecting: false,
					provinceSelecting_empty: true, // 正在选择省份, 未选中
					citySelecting_empty: false,
					districtAndCountySelecting_empty: false,
					isMunicipality: false, // 是否是直辖市
					isDistrictDicEmpty: false, // 字典中区县信息是否为空（第三级地区）
				}
			},
			watch: {
				//
				provinceSelecting(newVal) {
					if (newVal) {
						this.areaData = [...this.data];
						this.provinceSelecting = true;
						this.citySelecting = false;
						this.citySelecting_empty = false;
						this.districtAndCountySelecting = false;
						this.districtAndCountySelecting_empty = false;
						this.city = null;
						this.districtAndCounty = null;
						this.defaultVal = this.province;
						this.isSelectingDistrict = false;
					}
				},
				citySelecting(newVal) {
					if (newVal) {
						this.getCityData(this.province);
						this.citySelecting = true;
						this.citySelecting_empty = false;
						this.districtAndCountySelecting = false;
						this.districtAndCountySelecting_empty = false;
						this.districtAndCounty = null;
						this.defaultVal = this.city;
						this.isSelectingDistrict = false;
					}

				},

				data(newVal) {
					this.areaData = [...newVal];
				},
				areaData() {
				},
				districtAndCountySelecting() {
				},
				visible(newVal) {
					setTimeout(
						() => {
							if(!newVal) {this.destroySelector();}
						}, 600
					)
				}
			},
			methods: {
				stopChangeState(target){
					this[target] = true;
				},
				destroySelector() {
					const kidsLinkage = document.querySelector('#kidsLinkage');
					document.body.removeChild(this.$refs.kidsLinkage);
				},
				closeSelector() {
					this.exportData = {province:this.province, city: this.city, district: this.districtAndCounty, isDistrictDicEmpty: this.isDistrictDicEmpty};
					this.visible = false;
				},
				selectedNewVal(val) {
					switch (true) {
						case this.provinceSelecting:
						case this.provinceSelecting_empty:
							this.provinceSelecting = true;
							this.province = val;
							this.isSelectingDistrict = false;
							this.isMunicipality = isMunicipality(this.province);
							this.provinceChanged(val);
							break;
						case this.citySelecting:
						case this.citySelecting_empty:
							this.citySelecting = true;
							this.city = val;
							this.isSelectingDistrict = false;
							setTimeout(
								() => {
									this.isSelectingDistrict = true;
								},10
							);
							this.cityChanged(val);
							break;
						case this.districtAndCountySelecting:
						case this.districtAndCountySelecting_empty:
							this.districtAndCountySelecting = true;
							this.districtAndCounty = val;
							this.districtChanged();
							break;
					}
				},
				provinceChanged(province) {
					this.city = null;
					this.districtAndCounty = null;
					this.provinceSelecting = false;
					this.defaultVal = null;
					if (province) {
						this.provinceSelecting_empty = false;
						if (this.isMunicipality){
							this.isSelectingDistrict = false;
							setTimeout(
								() => {
									this.isSelectingDistrict = true;
								},10
							);
							this.districtAndCountySelecting_empty = true
						} else {
							this.citySelecting_empty = true
						}
						this.getCityData(province)
					} else {
						this.provinceSelecting_empty = true;
						this.areaData = [...this.data];
					}
				},
				async cityChanged(city) {
					this.districtAndCounty = null;
					this.citySelecting = false;
					this.defaultVal = null;
					if (city) {
						this.citySelecting_empty = false;
						this.districtAndCountySelecting = false;
						this.districtAndCountySelecting_empty = true;
						await this.getDistrictAndCountyData(city);
						if (!this.areaData || this.areaData.length === 0 || !this.areaData[0].label) {
							this.isDistrictDicEmpty = true;
							this.districtChanged();
						}
					} else {
						if (!this.provinceSelecting) {
							this.citySelecting_empty = true;
							this.getCityData(this.province);
						}
					}
				},
				districtChanged() {
					this.districtAndCountySelecting = false;
					this.defaultVal = null;
					this.areaData = [...this.data];
					this.closeSelector();
				},
				getCityData(label) {
					this.data.forEach((item) => {
						if (item.label === label) {
							if (this.isMunicipality) {
								this.districtAndCountyData = [...item.children[0].children]
								this.areaData = [...this.districtAndCountyData];
							} else {
								this.cityData = [...item.children];
								this.areaData = [...this.cityData]
							}
						}
					})
				},
				getDistrictAndCountyData(label) {
					this.cityData.forEach((item) => {
						if (item.label === label) {
							if (item.children) {
								this.districtAndCountyData = [...item.children];
								this.areaData = [...this.districtAndCountyData];
							} else {
								this.districtAndCountyData = null;
								this.areaData = null;
							}

						}
					})
				}
			},
    }
</script>

<style lang="scss">
	// 逻辑1： 选择省份时，如果选择了直辖市，下一个选择 label 要显示 '区县'， 选中的是否是直辖市根据 遍历直辖市区号数据 确定；
	// 逻辑2： 点击 label 中已选中的 省份/直辖市时，要显示 省份选择列表， 同样的选中 城市 时，要选择对应的城市选择列表
		@import "~@/assets/style/mixin.scss";
		.kids-linkage {
			position: absolute;
			width: 100%;
			height: 100%;
			left:50%;
			top:0;
			margin-left: -50%;
			display: flex;
			align-items: center;
			justify-content: center;
			z-index: 0;
			color: #fff;
			box-sizing: border-box;
			overflow: hidden;
			&__mask{
				@include fullScreenInMiddle();
				background: rgba(0, 0, 0, 0.7);
				z-index: 9999;
			}
			i {
				font-style: normal;
			}
			&--content{
				position: fixed;
				bottom: rem(-100);
				left: 50%;
				transform: translate(-50%, 0);
				z-index: 9999;
				height: rem(618);
				width: 100%;
				padding: rem(20) rem(16);
				background:rgba(255,255,255,1);
				border-radius:rem(8) rem(8) 0 0;
				box-sizing: border-box;
			}
			&--main{
				display: flex;
				flex-flow: column;
				height: rem(490);
				width: 100%;
				overflow: hidden;
			}
			&--header{
				display: flex;
				justify-content: space-between;
				align-items: center;
				&__title{
					font-size:rem(22);
					font-weight:600;
					color:rgba(51,51,51,1);
					line-height:rem(22);
				}
				&__icon_close{
					width: rem(14);
					height: rem(14);
					background: url("./image/icon_close@2x.png") center center no-repeat / 100%;
				}
			}
			&--label{
				padding: rem(32) 0 rem(6);
				border-bottom: 1px solid rgba(238,238,238,1);
				input{
					&+label{
						margin-right: rem(30);
						font-size: rem(14);
						font-weight:600;
						color:rgba(51,51,51,1);
						line-height:rem(14);
					}
					&:checked+label{
						position: relative;
						&::after{
							content:'__';
							width: rem(12);
							height: 1px;
							position: absolute;
							bottom: rem(8);
							left: 50%;
							transform: translateX(-50%);
							color:rgba(239, 76, 79, 1);

						}
					}
				}
			}
			@include AnimationBottomIn(128, -8%);
			&-enter-active{
				animation: BottomIn .6s ease-out;
			}
			&-leave-active {
				animation: BottomIn .6s ease-out reverse;
			}
		}


</style>
